'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.yearsFromNow;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/yearsFromNow.js
// module id = 765
// module chunks = 0